import React from 'react'

const Error = (props) => {
  if (props.data === undefined) {
    return (

      <div className="col-md-6 drop-in errorScreenUI">
        <div className="card"> 
          <div className="card-body tH">
            <h4>Something went wrong, Please contact your administrator..!</h4>
          </div>
        </div>
      </div>
    )

  } else {
    return (
      <div className="col-md-6 drop-in errorScreenUI">
        <div className="card card-danger">
          <div className="card-header widget-user-header">
            <h3 className="card-title">{props.data}</h3>
          </div>
          <div className="card-body tH">
            <h4>Something went wrong, Please contact your administrator..!</h4>
          </div>
        </div>
      </div>
    )

  }

}

export default Error